import { Realtime } from 'ably/browser/static/ably-commonjs.js';
import { makeRequest } from './api';

window.Ably = new Realtime('Qc7k9w.dPzPGA:GFbY7Tops_OEMP2s');

export const getAblyToken = async () => {
  const ablyRes = await makeRequest('post', 'getAblyToken');
  return ablyRes.data.data;
};
  
